export default __webpack_public_path__ + "resources/icons/d211-1da8.png";